module.exports = __webpack_public_path__ + "img/jelzin.70dbc4dd.png";